import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';

import * as $ from 'jquery';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DemandesAvisService } from '../../services/frapper/demandes_avis.service';
import { DossierService } from '../../services/frapper/dossier.service';
import { EnrollementService } from '../../services/frapper/enrollement.service';
import { AlertesService } from '../../services/public/alertes.service';
import { UsercourrierService } from '../../services/frapper/usercourrier.service';
import { AssignedService } from '../../services/frapper/assigned.service';
@Component({
  selector: 'app-add-avis',
  templateUrl: './add-avis.component.html',
  styleUrls: ['add-avis.component.scss'],
})
export class AddAvisComponent {
  
    modalRef!: BsModalRef;
    pageAvis: number = 1;
    my_tribunal:any = null
    doctype_name:any
  emeteur:any
  doctype:any
  data:any
  opened_avis:any
  owner:any
  list_avis = []
  CAN_WRITE_AVIS: boolean = true
  owners: any[] = [];

    constructor(private modalService: BsModalService,
        public options: ModalOptions,
       
        private role: EnrollementService,
        private alerte:AlertesService,
        public bsModalRef: BsModalRef,
        private dossierService: DossierService,
        private datePipe: DatePipe,
        private assignService:AssignedService,
        private courrier: UsercourrierService,
        private ngxService: NgxUiLoaderService,
        private demandeavisService: DemandesAvisService) {


      try{
        this.doctype_name = options.initialState.doctype_name
        this.doctype = options.initialState.doctype
        this.data = options.initialState.data
        this.opened_avis = options.initialState.opened_avis
        this.emeteur = options.initialState.emeteur
        this.owner = options.initialState.owner
        this.my_tribunal = JSON.parse(localStorage.getItem('my_tribunal'))
        console.log('dataaa=> ',this.opened_avis)
        console.log('data=> ',this.data)
        if (this.data != null ) {
          this.doctype = this.data.parenttype
          this.doctype_name = this.data.parent
          console.log('dataaa=> ',this.doctype_name,this.doctype,this.emeteur)
          if (this.data.is_open != 1 || this.data.user_demand3 != this.emeteur) {
           

            this.CAN_WRITE_AVIS = false;
            console.log('canwriteavis=> ',this.CAN_WRITE_AVIS)
              
          }
        }

        //console.log('tribunal_information====> ',tribunal_information)
      }catch (e) {
        console.log('ERROR ON GET TRIBUNAL====> ')
        this.my_tribunal=null
      }

      if(this.opened_avis && this.opened_avis.length > 0){
        this.owners = this.opened_avis.map(item => item.owner);
        console.log('owners=> ',this.owners);
      }

    }

    closeModal(){
      this.bsModalRef.hide()
    }

    formatDateTe(dateString: string): string {
      const datePart = dateString.split(" ")[0];
      const [year, month, day] = datePart.split("-");
      return `${day}-${month}-${year}`;
    }
    

    async getAllDemandeAvis(){
      this.ngxService.start() 
  
      // let filter = '[["doctype_type" , "=","' + this.doctype+ '"],["doctype_name" , "=","' + this.doctype_name+ '"],["emeteur" , "=","' + this.emeteur + '"]]'
      let filter = '[["doctype_type" , "=","' + this.doctype+ '"],["doctype_name" , "=","' + this.doctype_name+ '"]]'

      // let filter = null
      if (this.data!=null) { 
        filter = '[["doctype_type" , "=","' + this.data.parenttype+ '"],["doctype_name" , "=","' + this.data.parent+ '"],["emeteur" , "=","' + this.data.user_demand3 + '"]]'
      }
  


     await this.demandeavisService.getAllDemandeAvis(filter).then((res:any) => {
        try {
          let result = res.data
  
          this.list_avis = result
          console.log('result==>', result);
          
          this.ngxService.stop()
        } catch (error) {
          this.ngxService.stop()
          
          console.log('ERROR ON getting data avis ',error)
        }
  
        //console.log('DATA ====> ', this.data)
        //console.log('RES ====> ', res)
      },err=>{
        this.ngxService.stop();
        console.log('ERROR ON getting data dossier ',err)
        this.bsModalRef.hide()
        this.alerte.errorNotification('Dossier ','Une Erreur est survenue! Verifier que vous avez les droits sur ce dossier')
      })
    }



    closeWithMessage(message: string) {
      this.bsModalRef.hide();
      this.bsModalRef.onHidden.emit(message);
    }

    async onSubmit(form: NgForm){
      this.ngxService.start()
      let body_content = form.value
      body_content['doctype_type'] = this.doctype
      body_content['doctype_name'] = this.doctype_name
      body_content['emeteur'] = this.emeteur
      this.owner =  body_content.destinataire?? this.owner
      console.log('body=>',body_content);
      let profil = localStorage.getItem('profil')
      try {
        await this.demandeavisService.nouvelleDemandeAvis(body_content).then(async res => {
          
          let c_interne=  {
            "profil": profil,
            "destinataire": body_content.destinataire?? this.owner,
            "tag": res.data.action_1,
            "fichier": null,
            "message": body_content.avis
          }
          if(this.doctype =='Dossier'){
            c_interne["numéros_du_dossier"]= this.doctype_name
          }
          if(this.my_tribunal !=null){
            c_interne['tribunal'] = this.my_tribunal.name
          }
  
          await this.courrier.nouveauCourrierInterne(c_interne).then(res=>{
            this.assignService.doAssignation(this.courrier.Docatype_courrier_interne,res.data.name,[this.owner])
          })

         console.log('new avis=>',res.data);
         this.getAllDemandeAvis()
         form.reset()
         this.alerte.successNotification("Avis","avis ajouté")
         this.ngxService.stop()
       },
        error =>{
        console.log('Error ==> ',error)
        this.alerte.errorNotification('',"une erreur s'est produite, veillez reessayer")

          this.ngxService.stop()
        })
        
      } catch (error) {
        this.ngxService.stop()
      }
    }
  
  
  
  initializeStepper() {


    $(document).ready(function(){
      var current_fs, next_fs, previous_fs; //fieldsets
      var opacity;
      var current = 1;
      var steps = $("fieldset").length;


      setProgressBar(current);



      // Fonction pour définir la barre de progression
      function setProgressBar(curStep){
          var percent = (100 / steps) * curStep;
          percent = percent
          $(".progress-bar").css("width",percent+"%");
      }

      // Logique pour passer à l'étape suivante
      $(".next").click(function(){
          current_fs = $(this).parent();
          next_fs = $(this).parent().next();

          // Ajouter la classe "active" à l'étape suivante de la barre de progression
          $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

          // Afficher le fieldset suivant avec une animation
          next_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  next_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(++current);
      });

      // Logique pour revenir à l'étape précédente
      $(".previous").click(function(){
          current_fs = $(this).parent();
          previous_fs = $(this).parent().prev();

          // Retirer la classe "active" de l'étape actuelle de la barre de progression
          $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

          // Afficher le fieldset précédent avec une animation
          previous_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  previous_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(--current);
      });
  });

  }

  ngOnInit() {

    this.getAllDemandeAvis()
    $(document).ready(function(){
      var current_fs, next_fs, previous_fs; //fieldsets
      var opacity;
      var current = 1;
      var steps = $("#msform fieldset").length;

      setProgressBar(current);
      if ($("#msform fieldset").hasClass("second")) {
        // Cacher le premier fieldset et afficher le deuxième
        $("#msform fieldset").eq(0).hide();
        $("#msform fieldset").eq(1).show();
        current = 2;

        // Ajouter la classe "active" au deuxième élément de la barre de progression
        $("#progressbar li").eq(1).addClass("active");
        console.log("Au moins un élément fieldset a la classe 'cache'");
      }




      // Fonction pour définir la barre de progression
      function setProgressBar(curStep){
          var percent = (100 / steps) * curStep;
          percent = percent
          $(".progress-bar").css("width",percent+"%");
      }

      // Logique pour passer à l'étape suivante
      $(".next").click(function(){
          current_fs = $(this).parent();
          next_fs = $(this).parent().next();

          // Ajouter la classe "active" à l'étape suivante de la barre de progression
          $("#progressbar li").eq($("#msform fieldset").index(next_fs)).addClass("active");

          // Afficher le fieldset suivant avec une animation
          next_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  next_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(++current);
      });

      // Logique pour revenir à l'étape précédente
      $(".previous").click(function(){
          current_fs = $(this).parent();
          previous_fs = $(this).parent().prev();

          // Retirer la classe "active" de l'étape actuelle de la barre de progression
          $("#progressbar li").eq($("#msform fieldset").index(current_fs)).removeClass("active");

          // Afficher le fieldset précédent avec une animation
          previous_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  previous_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(--current);
      });
  });



  }
}


